module.exports = __webpack_public_path__ + "static/media/CGSE_Hero_New Zealand.c2ee7eba.jpg";